module.exports = __webpack_public_path__ + "static/media/icon_success.a7826d96.svg";